// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"952097ec","72":"47693180","87":"26354305","182":"73978839","216":"2d18e8d6","398":"d1e36d76","637":"12e6f397","742":"840f1d3d","977":"b2628b82"}[chunkId] + ".chunk.js";
};